import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { baseQueryWithAccount } from "@/redux/baseQuery";
import { Profile, ProfileOptions } from "@/redux/slices/profile/types";
import { transformProfile, transformProfileOptions } from "./helpers";
import { UpdateProfileParams } from "./types";

export const profileApi = createApi({
  reducerPath: "profileApi",
  baseQuery: baseQueryWithAccount("profile"),
  endpoints: (builder) => ({
    getProfile: builder.query<Profile, void>({
      query: () => "",
      transformResponse: transformProfile,
      providesTags: ["Profile"],
    }),
    getProfileOptions: builder.query<ProfileOptions, void>({
      query: () => `/options`,
      transformResponse: transformProfileOptions,
    }),
    updateProfile: builder.mutation<void, UpdateProfileParams>({
      query: (body) => ({
        url: "",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Profile"],
    }),
    updateAvatar: builder.mutation<void, FormData>({
      query: (body) => ({
        url: "/avatar",
        method: "POST",
        body,
      }),
    }),
  }),
  tagTypes: ["Profile"],
});

export const { useUpdateAvatarMutation, useLazyGetProfileQuery, useGetProfileQuery, useGetProfileOptionsQuery, useUpdateProfileMutation } =
  profileApi;
